export function usePaginationCanonical(
  currentPage: Ref<number>,
  pageSize: Ref<number>,
  pageKey: Ref<string>,
  sizeKey: Ref<string>,
  defaultSize: number
) {
  const route = useRoute();
  const dom = useDom();

  const canonicalQuery = computed(() => {
    const result: Record<string, string> = {};
    for (const key in route.query) {
      const value = route.query[key];
      if (Array.isArray(value)) {
        result[key] = value.join(',');
      } else if (value != null) {
        result[key] = value.toString();
      }
    }

    if (currentPage.value !== 1) {
      result[pageKey.value] = currentPage.value.toString();
    }

    if (pageSize.value !== defaultSize) {
      result[sizeKey.value] = pageSize.value.toString();
    }

    return result;
  });

  watch(
    canonicalQuery,
    (query) => {
      const search = Object.keys(query).length ? '?' + new URLSearchParams(query).toString() : '';
      useHead({
        link: [{ rel: 'canonical', href: `${dom?.window.location.origin}${route.path}${search}` }]
      });
    },
    { immediate: true }
  );
}
